<template>
    <common-content-spacer :isCenter="true" height="small">
        <img v-if="marker.isCompanyOffer" class="map-marker__company-cover" :alt="$t('alt.map_marker')" :src="coverImage" />
        <common-content-spacer v-if="marker.providerData" class="map-marker__data" :isCenter="true" height="small">
            <common-company-avatar
                v-if="marker.isCompanyOffer"
                ref="companyAvatar"
                class="map-marker__company-data"
                :company="marker.providerData"
                :shouldLeadToProfile="true"
                size="tiny"
            ></common-company-avatar>
            <common-user-avatar
                v-else
                ref="userAvatar"
                :user="marker.providerData"
                :shouldLeadToProfile="true"
                size="large"
            ></common-user-avatar>
            <span class="map-marker__name">{{ providerName(marker) }}</span>
            <span class="map-marker__offers-count">
                <span v-if="marker.offerCount">
                    {{ $t('components.locations.map_component.offer_count', { n: marker.offerCount }) }}
                </span>
                &nbsp;&nbsp;&nbsp;
                {{ $t('common.microcopy.reviews', { n: marker.numberOfRatings || 0 }) }} &nbsp;|&nbsp;
                <common-icon class="rating__icon" name="star" size="tiny-small"></common-icon>
                <span class="map-marker__rating">{{ marker.averageRating?.toFixed(1) || 0 }}</span>
            </span>
            <span class="map-marker__copy" @click="copyLocationToClipboard(marker.coordinates)">
                {{ $t('components.locations.map_component.copy_address') }}
                <common-icon name="copy" size="small"></common-icon>
            </span>
        </common-content-spacer>

        <common-buttons>
            <common-button
                size="micro"
                type="quaternary"
                :label="$t('components.locations.map_component.open_in_maps')"
                :href="getGoogleMapLocation(marker.coordinates)"
            ></common-button>
            <common-button
                v-if="showGoToProfile"
                size="micro"
                type="secondary"
                :label="$t('components.locations.map_component.go_to_profile')"
                @click="goToProfile"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>
<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        props: {
            marker: { type: Object, default: new Array() },
        },

        computed: {
            coverImage() {
                if (!this.marker.isCompanyOffer) {
                    return null
                }
                return this.marker.providerData.photoCover
                    ? this.marker.providerData.photoCover
                    : require('../../../../assets/images/company-cover-placeholder.png')
            },

            showGoToProfile() {
                return (
                    this.marker.providerData &&
                    this.$route.name !== RoutesEnum.USER.PROFILE &&
                    this.$route.name !== RoutesEnum.COMPANY.PROFILE &&
                    !this.$auth.isSubdomainActive()
                )
            },
        },

        methods: {
            getGoogleMapLocation(coordinates) {
                return `https://www.google.com/maps?daddr=${coordinates.lat},${coordinates.lng}`
            },

            copyLocationToClipboard(coordinates) {
                navigator.clipboard.writeText(`https://www.google.com/maps?daddr=${coordinates.lat},${coordinates.lng}`)
                this.$toast.success(this.$t('common.microcopy.copied'))
            },

            providerName(data) {
                if (!data?.providerData) {
                    return
                }
                return data.isCompanyOffer
                    ? data.providerData.name
                    : `${data.providerData.firstName} ${data.providerData.lastName}`
            },

            goToProfile() {
                this.marker.isCompanyOffer ? this.$refs.companyAvatar.avatarClick() : this.$refs.userAvatar.avatarClick()
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .rating__icon {
        color: $color-gold;
    }
    .map-marker {
        .leaflet-popup-content-wrapper {
            position: relative;
            width: 300px;
            @include breakpoint(smartphone-large) {
                max-width: 350px;
            }
        }

        &__name {
            font-size: 18px;
            font-weight: 500;
        }

        &__offers-count {
            color: $color-neutral-1;
            font-weight: 400;
            font-size: 14px;
        }

        &__company-cover {
            position: absolute;
            top: 0;
            width: 100%;
            min-height: 100px;
            max-height: 120px;
            object-fit: cover;
        }

        &__company-data {
            margin-top: 45px !important;
        }

        &__data {
            position: relative;
            margin-bottom: 10px;
            margin-top: 20px;
            z-index: 1;
        }

        &__copy {
            color: $color-link;
            cursor: pointer;
            margin-top: 5px !important;
        }

        &__rating {
            font-weight: 600;
            color: $color--txt-header-1;
            margin-left: 5px;
        }
    }
</style>
